var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-graph-container",style:(_vm.$attrs.style)},[(
			_vm.chartdata && _vm.chartdata.datasets && _vm.chartdata.datasets.length > 0
		)?_c('LineChart',{ref:"lineChart",style:(_vm.$attrs.style),attrs:{"chartData":_vm.chartdata,"chartOptions":_vm.mergedOptions}}):_c('div',{staticClass:"no-data"},[_vm._v("No chart data available")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }